import CollectionShareLink from '@/store/models/collections/CollectionShareLink'
import { DEFAULT_DURATION, DEACTIVATION_DURATION } from '@/utils/constants'

export default {
  // share link
  async getShareLink(_, collectionId) {
    const result = await this.$api.collection.shareLink(collectionId)
    // Backend returns null when no link exists; the axios interceptor
    // doesn't unwrap falsy responses, so extract manually if needed
    const shareLink = result?.of ? result : result?.data?.response ?? null

    if (!shareLink) return null

    await CollectionShareLink.insertOrUpdate({
      data: {
        ...shareLink,
        collectionId: shareLink.of,
      },
    })

    return shareLink
  },
  async createShareLink(_, { collectionId, duration, role, subCollectionIds }) {
    const token = await this.$api.collection.createShareLink(collectionId, {
      duration: duration || DEFAULT_DURATION,
      ...(role && { role }),
      ...(subCollectionIds && { subCollectionIds }),
    })

    return token
  },
  async editShareLink(_, { collectionId, shareLinkId, data }) {
    const result = await this.$api.collection.editShareLink(collectionId, shareLinkId, data)
    await CollectionShareLink.update({
      where: shareLinkId,
      data: result,
    })

    return result
  },
  async deactivateShareLink(_, { collectionId, shareLinkId }) {
    const result = await this.$api.collection.editShareLink(collectionId, shareLinkId, {
      duration: DEACTIVATION_DURATION,
    })

    await CollectionShareLink.update({
      where: shareLinkId,
      data: result,
    })

    return result
  },
  async deleteShareLink(_, { collectionId, shareLinkId }) {
    await this.$api.collection.removeShareLink(collectionId, shareLinkId)
    await CollectionShareLink.delete(shareLinkId)
  },
  // email
  async inviteEmails(_, { collectionId, emails, role, subCollectionIds }) {
    return this.$api.collection.inviteEmails(collectionId, {
      invites: emails,
      ...(role && { role }),
      ...(subCollectionIds && { subCollectionIds }),
    })
  },
}
